import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import "../CSS/ImageSlider.css";
import Image1 from "../Images/SImage_1.jpg";
import Image2 from "../Images/SImage_2.jpg";
import Image3 from "../Images/SImage_3.jpg";
import Image4 from "../Images/SImage_4.jpg";
import axios from "axios";

const ImageSlider = () => {

    const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    fetchGalleryData();
  }, []);

  const fetchGalleryData = async () => {
    try {
      const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getGalleryContent1");
      const data = response.data ? Object.values(response.data) : [];
      setGalleryData(data);
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    }
  };
  return (
    <>
     {galleryData.length > 0 && galleryData.map((gallery, index) => (
        <div key={index}>
        <h1 className="text-center">{gallery.title2}</h1>
        <p className="Galleryp mb-4">{gallery.description2}</p>
    <div style={{width: "100%"}}>
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={3}
        pagination={{ clickable: true }}
        loop={true}
        width={800}
        autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
        }}
        className='gallery-swiper'
      >
       {gallery.subtitles && gallery.subtitles.map((subtitle, idx) => (
            <SwiperSlide key={idx}>
              {idx % 2 === 0 ? (
                // Image above text for even slides
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={subtitle.subimage}
                    alt={subtitle.subtitle}
                    style={{ width: '100%', height: '300px', borderRadius: '10px' }}
                  />
                  <h3 style={{ marginTop: '10px' }}>{subtitle.subtitle}</h3>
                  {/* <p style={{marginTop: '5px'}}>{subtitle.subdescription}</p> */}
                </div>
              ) : (
                // Text above image for odd slides
                <div style={{ textAlign: 'center' }}>
                  <h3 style={{ marginBottom: '10px' }}>{subtitle.subtitle}</h3>
                  <img
                    src={subtitle.subimage}
                    alt={subtitle.subtitle}
                    style={{ width: '100%', height: '300px', borderRadius: '10px' }}
                  />
                </div>
              )}
            </SwiperSlide>
          ))}

      </Swiper>
    </div>
    </div>
    ))}
    </>
  );
};

export default ImageSlider;
